/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exception_Notes_PlaceholderInputs */

const en_exception_notes_placeholder = /** @type {(inputs: Exception_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Briefly describe what happened so the service desk doesn't have to call you back.`)
};

const ja_exception_notes_placeholder = /** @type {(inputs: Exception_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サービスデスクからの折り返し連絡が不要になるよう、状況を簡潔に記入してください。`)
};

const fr_exception_notes_placeholder = /** @type {(inputs: Exception_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décrivez brièvement ce qui s'est passé pour éviter que le service desk ne vous rappelle.`)
};

const de_exception_notes_placeholder = /** @type {(inputs: Exception_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreiben Sie kurz, was passiert ist, damit der Service Desk nicht zurückrufen muss.`)
};

/**
* | output |
* | --- |
* | "Briefly describe what happened so the service desk doesn't have to call you back." |
*
* @param {Exception_Notes_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const exception_notes_placeholder = /** @type {((inputs?: Exception_Notes_PlaceholderInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exception_Notes_PlaceholderInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exception_notes_placeholder(inputs)
	if (locale === "ja") return ja_exception_notes_placeholder(inputs)
	if (locale === "fr") return fr_exception_notes_placeholder(inputs)
	return de_exception_notes_placeholder(inputs)
});